import React from "react";
import type { PropsWithChildren } from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import * as base from "theme/base";
import { pageContentPadding } from "components/PageContent/PageContent";

/** The light-mode analogue of the dark-mode bar background below: a step off the page's own paper, not pure white. */
const lightBarBackground = base.grey20;
const darkBarBackground = "rgb(27, 49, 69)";

type PageHeaderBarProps = PropsWithChildren<{
  /** `false` keeps the padding but drops the width cap, for a page that wants to fill the screen. */
  maxWidth?: number | false;
  sx?: SxProps<Theme>;
}>;

/**
 * The bar a detail page's header sits in: full width, so it reads as chrome rather than a card, with
 * its content capped at `pageContentMaxWidth` and centered to line up with the `PageContent` below
 * it. A background shade stands in for the card edge `PaperLayout` used to draw around the header.
 * @param props
 */
export function PageHeaderBar(props: PageHeaderBarProps) {
  const { children, maxWidth = false, sx } = props;
  return (
    <Box
      sx={[
        (theme) => ({
          backgroundColor: theme.palette.mode === "dark" ? darkBarBackground : lightBarBackground,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box
        sx={{
          boxSizing: "border-box",
          ...(maxWidth !== false && { maxWidth, mx: "auto" }),
          padding: pageContentPadding,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
